<template>
  <div>
    <div class="part basic">
      <header>基本信息</header>
      <section v-loading.lock="fullscreenLoading">
        <div class="row">
          <div class="form_group">
            <div class="label">
              供应名称<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control">
              <input
                ref="keyword"
                v-model="title"
                :class="title ? 'highlight' : ''"
                type="text"
                maxlength="28"
                placeholder="请输入供应名称"
                @input="guessWord"
              >
            </div>
            <div
              v-if="!showSearch && (productObj.breed_name || productObj.product_name || productObj.cid2_name || productObj.cid1_name)"
              class="selected_word"
            >
              {{ productObj.breed_name || productObj.product_name || productObj.cid2_name || productObj.cid1_name }}
            </div>
            <div
              v-if="showSearch"
              class="select_list_group"
            >
              <input
                ref="category"
                type="text"
                placeholder="输入供应名称"
                @input="guessAnotherWord"
              >
              <ul
                v-if="categoryList.length"
                class="select_list"
              >
                <li
                  v-for="cate in categoryList"
                  :key="cate.id"
                  @click="selectThis(cate)"
                >
                  {{ cate.text }}
                </li>
              </ul>
              <ul
                v-if="showSearch && searching"
                class="select_list"
                style="padding-left: 10px;"
              >
                暂无数据
              </ul>
            </div>
            <button
              v-if="!showSearch && (productObj.breed_name || productObj.product_name || productObj.cid2_name || productObj.cid1_name)"
              class="btn reselect"
              @click="reselect"
            >
              重新选择
            </button>
          </div>
          <div
            v-if="showBar"
            class="form_group xs_form_group"
          >
            <el-checkbox
              v-model="stall"
              @change="changeStall"
            /><span
              style="margin-left: -20px; margin-top: 2px;"
            >搜索时优先展示该供应</span>
          </div>
        </div>
        <div class="row">
          <div class="form_group">
            <div class="label">
              供应产地<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control no_border addr_group">
              <AddrList
                :init-value="locationObj.location_name"
                :active-color="locationObj.location_name ? '#333' : '#999'"
                @selectCallback="selectThisAddr"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form_group">
            <div class="label">
              供应图片<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control form_control_upload">
              <ul
                class="gallery"
              >
                <draggable
                  v-model="files"
                  group="people"
                  @start="drag=true"
                  @end="drag=false"
                >
                  <li
                    v-for="(file, idx) in files"
                    :key="idx+file.p_url"
                  >
                    <template v-if="file">
                      <img
                        v-if="file.file_type == 0"
                        :src="file.p_url | aspectFill(360, 360)"
                        @click="previewImg(file)"
                      ><span
                        class="del_btn"
                        style="cursor: pointer;"
                        @click="fileDel(file, idx)"
                      />
                      <video
                        v-if="file.file_type == 1"
                        :src="file.v_url.indexOf('http://video.yimutian.com/') > -1 ? file.v_url : 'http://video.yimutian.com/'+file.v_url"
                        @click="previewImg(file)"
                      />
                      <img
                        v-if="file.file_type==1"
                        class="play_btn"
                        src="https://h5.ymt.com/asset_static/build/wechat_miniapp/images/syq/btn_play.png"
                        alt=""
                        @click="previewImg(file)"
                      >
                      <span
                        v-if="files.filter(x => x.file_type == 0).length && files.filter(x => x.file_type == 0)[0].p_url === file.p_url"
                        class="cover"
                      >封面</span>
                    </template>
                  </li>
                </draggable>
                <li
                  v-if="maximum > 0"
                  style="border: 1px dashed #b7b7b7;cursor: pointer;margin-right: 0; vertical-align: top;"
                >
                  <file-upload
                    ref="upload"
                    :name="name"
                    :post-action="postAction"
                    :maximum="maximum"
                    :custom-action="customAction"
                    :multiple="true"
                    :size="1024 * 1024 * 10"
                    class="upload_area"
                    extensions="gif,jpg,jpeg,png,mp4,m4v,mov"
                    accept="image/gif, image/jpg, image/jpeg, image/png, video/mp4, video/x-m4v, video/mov"
                    @input="updatetFiles"
                    @input-file="inputFile"
                  >
                    <div class="upload_area">
                      <img
                        src="http://img.yimutian.com/crm/5d134734885b9303cb184d968c50c795.png"
                        style="width: 24px;height: 24px;"
                      >
                      <span style="margin-top: 6px;">图片/视频</span>
                    </div>
                  </file-upload>
                </li>
              </ul>
              <p class="tip">
                建议尺寸：800*800像素，你可以拖拽图片调整顺序，最多上传15张
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form_group">
            <div class="label">
              供应描述<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control form_control_textarea">
              <textarea
                v-model="desc"
                placeholder="详细介绍下你供应的质量，服务"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="part basic">
      <header>SKU价格设置</header>
      <section>
        <div class="row">
          <div class="form_group">
            <div class="label">
              价格单位<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control no_border">
              <BaseSeletion
                :init-value="unitObj.label"
                :options="unitOptions"
                err-msg="请先输入正确的供应名称"
                @selectCallback="selectThisOption"
              />
            </div>
          </div>
        </div>
        <ul>
          <li
            v-for="(item, index) in suppliesSku"
            :key="index"
            class="row"
            style="list-style: none;"
          >
            <div class="form_group">
              <div class="label">
                规格{{ index+1 }}<img
                  v-if="index==0"
                  src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                  alt=""
                >
              </div>
              <div class="form_control">
                <input
                  v-model="item.title"
                  :class="item.title ? 'highlight' : ''"
                  type="text"
                  placeholder="自定义商品规格"
                >
              </div>
              <div class="form_control money_input">
                <input
                  v-model="item.price"
                  :class="item.title ? 'highlight' : ''"
                  type="text"
                  @input="checkInput($event, index)"
                >
              </div>
              <button
                v-if="suppliesSku.length > 1"
                style="background-color: transparent;"
                @click="delThisSku(index)"
              >
                <img
                  style="width: 20px;height: 20px;margin-left: 20px;margin-top: 4px;"
                  src="http://img.yimutian.com/crm/5d1302df885b9303cb181dbe071e781f.png"
                  alt=""
                >
              </button>
            </div>
          </li>
        </ul>
        <div
          v-if="suppliesSku.length < 5"
          class="row"
        >
          <div class="form_group xs_form_group">
            <button
              class="btn btn_special"
              @click="addSuppliesSku"
            >
              添加规格
            </button>
          </div>
        </div>
        <div
          v-if="!isDouNiu"
          class="row"
          style="margin-bottom: 20px; text-align: center"
        >
          <button
            class="btn btn_submit"
            @click="submitForm"
          >
            {{ supplyId ? '保存' : '发布' }}
          </button>
        </div>
      </section>
    </div>
    <div
      v-if="isDouNiu"
      class="part basic"
    >
      <header>关联供应商</header>
      <section>
        <div class="row">
          <div class="form_group">
            <div class="label">
              供应商<img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439c6610d8ab.png"
                alt=""
              >
            </div>
            <div class="form_control no_border">
              <BaseSeletion
                :init-value="vendorObj.customer_id ? vendorObj.stall_name + '-' + vendorObj.stall + '-' + vendorObj.customer_name : '-请选择结算供应商-'"
                :options="vendorList"
                :active-color="vendorObj.customer_id ? '#333' : '#999'"
                err-msg="失败了，请稍后再试"
                @selectCallback="selectThisVendor"
              />
            </div>
          </div>
        </div>
        <div
          class="row"
          style="margin-bottom: 20px;"
        >
          <button
            class="btn btn_submit btn_submit_special"
            @click="submitForm"
          >
            {{ supplyId ? '保存' : '发布' }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import draggable from 'vuedraggable'
import fileUpload from '@ymt/vue-upload-component'
import * as utils from '@/utils.js'
import { publish } from '@/api'
import BaseSeletion from '../components/BaseSelection'
import AddrList from '../components/AddrList'
import { toFullString } from '../unit'
export default {
  components: {
    fileUpload,
    BaseSeletion,
    AddrList,
    draggable
  },
  // 从发布详情页面跳到发布页面
  beforeRouteEnter(to, from, next) {
    if (!to.params.supplyId && from.params.supplyId) {
      next(vm => vm.initialize())
    } else {
      next()
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      ajaxLock: false, //  控制提交按钮频率
      searching: false, // 是否正在搜索中
      name: 'imgfile',
      postAction: 'https://gfw.ymt.com/img/upload?bucket=crm',
      supplyId: Number(this.$route.params.supplyId) || '',
      unitOptions: [], // 单位下拉列表
      vendorList: [], // 供应商列表
      showBar: false, // 控制高级搜索；以及搜索推荐结果
      showSearch: false, // 是否展示下拉搜索框
      categoryList: [], // 品类下拉搜索列表
      isDouNiu: false, // 是否豆牛业务员角色
    }
  },
  computed: {
    ...mapState({
      // files: state => state.supply.files, // 显示图片视频
      unitObj: state => state.supply.unitObj, // 显示单位
      suppliesSku: state => state.supply.suppliesSku, // SKU价格设置
      locationObj: state => state.supply.locationObj, // 产地信息
      maximum: state => state.supply.maximum, // 上传的最大个数
      vendorObj: state => state.supply.vendorObj // 选中的供应商信息
    }),
    title: {
      get() {
        return this.$store.state.supply.title
      },
      set(value) {
        this.$store.commit('supply/updateTitle', value)
      }
    },
    files: {
      get() {
        return this.$store.state.supply.files
      },
      set(value) {
        this.$store.commit('supply/updateFilesOrder', value)
      }
    },
    stall: {
      // 搜索推荐位是否优先展示
      get() {
        return this.$store.state.supply.stall
      },
      set(value) {
        this.$store.commit('supply/updateStall', value)
      }
    },
    // 供应名称
    productObj: {
      get() {
        return this.$store.state.supply.productObj
      },
      set(value) {
        this.$store.commit('supply/updateProductObj', value)
      }
    },
    desc: {
      // 商品描述
      get() {
        return this.$store.state.supply.desc
      },
      set(value) {
        this.$store.commit('supply/updateDesc', value)
      }
    }
  },
  created() {
    this.initialize()
    this.checkPrevillige() // 校验是否豆牛角色
    if (this.$route.params.supplyId) {
      // 获取供应详情
      this.showBar = true // 详情页展示 是否优先推荐位
      this.getSupplyDetail()
    }
  },
  methods: {
    selectThisVendor(cur) {
      // 选择此供应商
      this.$store.commit('supply/updateVendor', cur)
    },
    getVendor() {
      publish.getVendor({supply_id: this.supplyId}).then(({data: res}) => {
        const {customer_name, stall_name, stall} = res.result.vendor_info
        this.$store.commit('supply/updateVendor', {
          customer_name: customer_name,
          customer_id: res.result.vendor_cid,
          stall_name: stall_name,
          stall: stall
        }
        )
      })
    },
    // 是否豆牛业务员角色，如果是则拉取供应商列表
    checkPrevillige() {
      publish.checkPrevillige({resId: 1224}).then(({data: res}) => {
        this.isDouNiu = res.data
        if (this.isDouNiu) {
          publish.getVendorList({start: 0, size: 0}).then(({data: res}) => {
            this.vendorList = res.result.map(i => { i.label = i.stall_name + '-' + i.stall + '-' + i.customer_name; i.value = i.customer_id; return i; })
            if (this.supplyId) { // 查找对应供应商信息
              this.getVendor()
            }
          })
        }
      })
    },
    previewImg(file) {
      if (file.file_type == 0) {
        const p_url =
          file.p_url.indexOf('http://img.yimutian.com/') > -1
            ? file.p_url
            : `http://img.yimutian.com/${file.p_url}`
        this.$alert(
          `<img style="width: 100%;max-width: 390px;" src=${p_url}>`,
          '预览',
          {
            dangerouslyUseHTMLString: true
          }
        )
      } else {
        const v_url =
          file.v_url.indexOf('http://video.yimutian.com/') > -1
            ? file.v_url
            : `http://video.yimutian.com/${file.v_url}`

        this.$alert(
          `<video style="width: 100%;max-width: 390px;max-height: 500px;" src=${v_url} autoplay controls="controls">`,
          '预览',
          {
            dangerouslyUseHTMLString: true
          }
        )
      }
    },
    async customAction(file, component) {
      if (file.file.type.indexOf('image/') == -1) {
        this.name = 'file'
        // this.postAction = 'https://up.ymt.com/video?bucket=misc'
        this.postAction = '/api/video/video-upload/?bucket=misc'
      } else {
        this.name = 'imgfile'
        this.postAction = 'https://gfw.ymt.com/img/upload?bucket=crm'
      }
      file = component.update(file, {
        postAction: this.postAction
      })
      return Vue.nextTick().then(() => {
        if (component.features.html5) {
          if (component.shouldUseChunkUpload(file)) {
            return component.uploadChunk(file)
          }
          if (file.putAction) {
            return component.uploadPut(file)
          }
          if (file.postAction) {
            return component.uploadHtml5(file)
          }
        }
        if (file.postAction) {
          return component.uploadHtml4(file)
        }
        throw new Error('No action configured')
      })
    },
    checkInput(e, idx) {
      e.target.value =
        e.target.value.match(/^\d*(\.?\d{0,2})/g) ||
        e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] ||
        null
      const paramOb = {
        idx,
        value: e.target.value
      }
      this.$store.commit('supply/updateSupplySkuPrice', paramOb)
    },
    getSupplyDetail() {
      const paramOb = {
        supply_id: this.supplyId
      }
      publish.getSupplyDetail(paramOb).then(({ data: res }) => {
        if (res.status == 0) {
          this.$store.commit('supply/updateSupplyInfo', res)
          const { product_id } = res
          // 获取单位
          publish
            .getUnits({ product_id })
            .then(({ data: res }) => {
              if (res.status == 0 && res.price_items) {
                const priceItems = res.price_items
                let tempArr = []
                for (let i of priceItems) {
                  let tempObj = {}
                  tempObj.value = i
                  tempObj.label = toFullString(i + '')
                  tempArr.push(tempObj)
                }
                this.unitOptions = tempArr
              }
            })
        } else {
          const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
          this.$message(errMsg)
        }
      })
    },
    initialize() {
      this.$store.commit('supply/initialize')
    },
    guessWord: utils.debounce(function() {
      const keyword = this.$refs.keyword.value
      if (keyword !== '') {
        this.showBar = true
      } else {
        this.showBar = false
        this.$store.commit('supply/updateProduct', null)
      }
      if (!keyword.trim()) {
        this.$store.commit('supply/updateProduct', null)
        return
      }
      publish.guessWord({ query: keyword.trim() }).then(({ data: res }) => {
        if (res.result && res.result.length) {
          this.commonSelect(res.result[0])
        } else {
          this.$store.commit('supply/updateProduct', null)
        }
      })
    }, 300),
    guessAnotherWord: utils.debounce(function() {
      const keyword = this.$refs.category.value
      if (keyword == '') {
        this.categoryList = []
        return
      }
      publish.guessSuggests(keyword).then(({ data: res }) => {
        if (res.result && res.result.length) {
          const categoryList = res.result || []
          this.categoryList = categoryList
          this.searching = false
        } else {
          this.categoryList = []
          this.searching = true
        }
      })
    }, 300),
    reselect() {
      this.searching = false
      this.showSearch = true
      this.$nextTick(() => {
        this.$refs.category.focus()
      })
      this.$store.commit('supply/updateProduct', null)
    },
    selectThis(cur) {
      this.searching = false
      this.commonSelect(cur)
      this.showSearch = false
      this.categoryList = []
      // this.$store.commit("supply/updateTitle", '')
    },
    commonSelect(selected) {
      let {
        cid2_name = '',
        cid1_name = '',
        product_name = '',
        breed_name = '',
        breed_id = 0,
        cid1 = 0,
        cid2 = 0,
        product_id = 0,
        id,
        name = ''
      } = selected
      let productObj = {
        cid2_name,
        cid1_name,
        breed_name,
        product_name: product_name || name || '',
        breed_id,
        cid1,
        cid2,
        product_id: product_id || id || 0
      }
      // 获取交易设置数据
      // 获取单位
      const param = {
        product_id: product_id || 487854 // 默认为其它
      }
      publish
        .getUnits(param)
        .then(({ data: res }) => {
          if (res.status == 0 && res.price_items) {
            const priceItems = res.price_items
            if (!priceItems.length) {
              this.$store.commit('supply/initialUnit', this.unitOptions[0])
              return
            }
            let tempArr = []
            for (let i of priceItems) {
              let tempObj = {}
              tempObj.value = i
              tempObj.label = toFullString(i + '')
              tempArr.push(tempObj)
            }
            this.unitOptions = tempArr
            this.$store.commit('supply/updateUnit', this.unitOptions[0])
          }
        })
      // 默认选中第一个
      this.$store.commit('supply/updateProduct', productObj)
    },
    changeStall(e) {
      this.$store.commit('supply/updateStall', e)
    },
    // 添加规格
    addSuppliesSku() {
      this.$store.commit('supply/addSuppliesSku')
    },
    delThisSku(index) {
      this.$store.commit('supply/delThisSku', index)
    },
    // 单位选择
    selectThisOption(param) {
      this.$store.commit('supply/updateUnit', param)
    },
    // 产地选择
    selectThisAddr(param) {
      this.$store.commit('supply/updateLocation', param)
    },
    fileDel(file, idx) {
      this.$store.commit('supply/delFile', idx)
      // item.id && this.$refs.upload.remove(item.id)
      // this.$refs.upload.remove(item)
    },
    inputFile(newFile, oldFile) {
      // 自动上传
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    updatetFiles(value) {
      this.fullscreenLoading = true;
      value &&
        value.forEach(i => {
          if (i.active == false && i.success == true) {
            // 单个文件单独提交，同时清除upload文件缓存
            this.$store.commit('supply/addFiles', i)
            this.$refs.upload.remove(i)
          }
          // 不支持的文件格式，例如webp
          if (i.active === false && i.error) {
            if (i.error === 'size') {
              this.$message('图片或者视频不能超出10M，请重新上传')
              this.$refs.upload.remove(i)
            } else {
              this.$message(i.error)
              this.$refs.upload.remove(i)
            }
            this.fullscreenLoading = false
          }
        })
      if (this.$refs.upload.files.length === 0) {
        this.fullscreenLoading = false
      }
    },
    // 发布 or 编辑保存供应
    submitForm() {
      if (this.isDouNiu && this.vendorObj && !this.vendorObj.customer_id) {
        Message.info({
          message: '请选择供应商'
        })
        return
      }
      if (this.title && this.title.length > 28) {
        Message.info({
          message: '供应名称过长，最大长度不能超过28个字符'
        })
        return
      }
      if (!this.productObj || (!this.productObj.product_id && !this.productObj.cid2 && !this.productObj.cid1)) {
        Message.info({
          message: '请填写供应名称'
        })
        return
      }
      if (
        !this.locationObj ||
        this.locationObj.location_name == undefined ||
        !this.locationObj.location_id
      ) {
        Message.info({
          message: '请填写供应产地'
        })
        return
      }
      if (!this.desc) {
        Message.info({
          message: '请填写商品描述'
        })
        return
      }
      // 完整sku校验
      const checkSku = this.suppliesSku.every(i => i.price && i.title)
      if (!checkSku) {
        Message.info({
          message: '请检查sku价格设置缺省项，至少填写一项规格',
          duration: 4000
        })
        return
      }
      const supplies_sku = this.suppliesSku.map(i => {
        return {
          unit: this.unitObj.value,
          price: Math.round(i.price * 100),
          title: i.title,
          supplies_sku_id: i.supplies_sku_id ? i.supplies_sku_id : undefined
        }
      })
      const {
        breed_id = 0,
        cid1: category_id_lvl1,
        cid2: category_id_lvl2,
        product_id,
        product_name
      } = this.productObj
      const unit = this.unitObj.value
      if (
        !(
          this.files.length &&
          this.files.every(
            file => typeof file === 'object' && Object.keys(file).length
          )
        )
      ) {
        this.$message('请上传供应图片/视频')
        return
      }
      const video_img = this.files.map(file => {
        if (file.file_type == 0) {
          return {
            p_url:
              file.p_url.indexOf('http://img.yimutian.com/') > -1
                ? file.p_url.slice(24)
                : file.p_url,
            file_type: 0
          }
        }
        return {
          pre_url: this.supplyId ? file.pre_url : '',
          v_url:
            file.v_url.indexOf('http://video.yimutian.com/') > -1
              ? file.v_url.slice(26)
              : file.v_url,
          file_type: 1
        }
      })
      // 价格取规格里面最小值
      const smallPrice = this.suppliesSku.reduce((smaller, cur) => {
        if (cur.price - '' < smaller) {
          smaller = cur.price - ''
        }
        return Math.round(smaller * 100)
      }, this.suppliesSku[0].price)
      const additional = this.desc
      const title = this.title || product_name
      const { location_id, country_code, adcode } = this.locationObj
      let paramOb = {
        category_id_lvl1,
        category_id_lvl2,
        product_id,
        breed_id,
        location_id,
        adcode,
        country_code,
        properties: [],
        unit,
        price: smallPrice - '',
        additional,
        video_img,
        title,
        stall: this.stall ? 1 : 0, // 搜索推荐位 0 未选中 1 选中
        supplies_sku,
        advanced: []
      }
      if (this.ajaxLock) return
      this.ajaxLock = true
      // 豆牛角色发布or编辑供应，调两遍接口，由于吕思rpc接口，先调宋健的，然后调吕思的
      if (this.isDouNiu && this.vendorObj.customer_id) {
        paramOb = {...paramOb, sku_type: 5}
        if (this.supplyId) {
          paramOb = Object.assign({}, paramOb, { supply_id: this.supplyId })
          // 编辑供应
          const postData = {
            supply_id: this.supplyId,
            vendor_cid: this.vendorObj.customer_id
          }
          publish.editSupply(paramOb).then(({ data: res }) => {
            if (res.status == 0) {
              if (
                res.popup &&
                res.popup.pop_payload &&
                res.popup.pop_payload.title === '发布失败' &&
                (res.popup.pop_payload.sub_title || '').indexOf('实名认证') !== -1
              ) {
                this.$message('发布失败，请下载一亩田App完成实名认证！')
                return
              }
              publish.relateVendorSupply(postData).then(({ data: res }) => {
                if (res.status == 0) {
                  this.$router.push({ name: 'publishSuccess' })
                  this.ajaxLock = false
                } else {
                  this.ajaxLock = false
                  const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
                  this.$message(errMsg)
                }
              })
            } else {
              this.ajaxLock = false
              const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
              this.$message(errMsg)
            }
          })
        } else {
          // 发布供应
          publish.publishSupply(paramOb).then(({ data: res }) => {
            if (res.status == 0) {
              if (
                res.popup &&
                res.popup.pop_payload &&
                res.popup.pop_payload.title === '发布失败' &&
                (res.popup.pop_payload.sub_title || '').indexOf('实名认证') !== -1
              ) {
                this.$message('发布失败，请下载一亩田App完成实名认证！')
                return
              }
              const postData = {
                supply_id: res.supply_id,
                vendor_cid: this.vendorObj.customer_id
              }
              publish.relateVendorSupply(postData).then(({ data: res }) => {
                if (res.status == 0) {
                  this.$router.push({ name: 'publishSuccess' })
                  this.ajaxLock = false
                } else {
                  this.ajaxLock = false
                  const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
                  this.$message(errMsg)
                }
              })
            } else {
              this.ajaxLock = false
              const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
              this.$message(errMsg)
            }
          })
        }
      } else {
        // 普通角色发布供应
        if (this.supplyId) {
          paramOb = Object.assign({}, paramOb, { supply_id: this.supplyId })
          // 编辑供应
          publish.editSupply(paramOb).then(({ data: res }) => {
            if (res.status == 0) {
              this.$router.push({ name: 'publishSuccess' })
              this.ajaxLock = false
            } else {
              this.ajaxLock = false
              const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
              this.$message(errMsg)
            }
          })
        } else {
          // 发布供应
          publish.publishSupply(paramOb).then(({ data: res }) => {
            if (res.status == 0) {
              if (
                res.popup &&
                res.popup.pop_payload &&
                res.popup.pop_payload.title === '发布失败' &&
                (res.popup.pop_payload.sub_title || '').indexOf('实名认证') !== -1
              ) {
                this.$message('发布失败，请下载一亩田App完成实名认证！')
                return
              }
              this.$router.push({ name: 'publishSuccess' })
              this.ajaxLock = false
            } else {
              this.ajaxLock = false
              const errMsg = res.user_msg || (res.popup && res.popup.pop_payload && res.popup.pop_payload.title) || '出错了'
              this.$message(errMsg)
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@xs-margin: 10px;
@md-margin: 20px;
.part {
  padding: @md-margin;
  margin-bottom: @md-margin;
  background: #fff;
  header {
    font-weight: bold;
    font-size: 16px;
    color: #333;
  }
  .row {
    margin-top: @md-margin;
  }
  .form_group {
    display: flex;
    align-items: flex-start;
    .label {
      display: flex;
      align-items: center;
      width: 90px;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      & > img {
        margin-left: 4px;
        width: 10px;
        height: 10px;
      }
    }
    .lg_label {
      width: 108px;
    }
    .form_control {
      &.no_border {
        border: 0 none;
      }
      &.component_group {
        position: relative;
        width: 120px;
        & > input {
          padding-right: 40px;
        }
        span {
          position: absolute;
          right: 0;
          top: 50%;
          width: 40px;
          height: 20px;
          border-left: 1px solid #b7b7b7;
          transform: translateY(-50%);
          text-align: center;
          font-size: 14px;
          line-height: 18px;
        }
      }
      &.v_centerlize {
        display: flex;
        align-items: center;
      }
      &.form_control_textarea,
      &.form_control_upload {
        width: auto;
        height: auto;
      }
      &.form_control_upload {
        border: 0 none;
        flex: 1;
        & > .pic {
          width: 90px;
          height: 90px;
          border-radius: 2px;
        }
        & > .tip {
          color: #666;
          font-size: 12px;
        }
      }
      &.form_control_textarea textarea {
        color: #333;
      }
      &.form_control_textarea textarea::-webkit-input-placeholder {
        color: #b3b3b3;
      }

      width: 400px;
      border: 1px solid #b7b7b7;
      border-radius: 2px;
      font-weight: 500;
      height: 30px;
      box-sizing: border-box;
      &.money_input {
        margin-left: @xs-margin;
        &::before,
        &::after {
          position: absolute;
          content: "";
          left: 15px;
          top: 50%;
          width: 30px;
          height: 28px;
          background: #f2f2f2;
          transform: translate(-50%, -50%);
        }
        &::after {
          content: "￥";
          left: 20px;
          top: 19px;
          background: transparent;
        }
        position: relative;
        width: 100px;
        height: 30px;
        & > input {
          padding-left: 40px;
        }
      }
      & > input,
      & > textarea {
        width: 100%;
        padding: 5px 10px;
        font-size: 14px;
        color: #999;
        box-sizing: border-box;
      }
      & > input.highlight {
        color: #333;
      }
      & > textarea {
        width: 552px;
        height: 70px;
      }
    }
    .selected_word {
      min-width: 80px;
      padding: 5px 10px;
      text-align: center;
      line-height: 20px;
      height: 30px;
      background: #f2f2f2;
      border-radius: 2px;
      box-sizing: border-box;
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      color: #666660;
      margin-left: 10px;
    }
    .select_list_group {
      position: relative;
      width: 300px;
      line-height: 20px;
      margin-left: 10px;
      border: 1px solid #b7b7b7;
      border-radius: 2px;
      padding: 5px 10px;
      font-size: 14px;
      color: #999;
      font-weight: 500;
      box-sizing: border-box;
      height: 30px;
      & > input {
        width: 100%;
      }
      & > .select_list {
        padding: 5px 0;
        left: 0;
        top: 30px;
        right: 0;
        position: absolute;
        overflow: hidden;
        border: 1px solid #b7b7b7;
        border-radius: 2px;
        border-top: 0 none;
        background: #fff;
        z-index: 1;
        li {
          list-style: none;
          padding: 5px 10px;
          font-size: 14px;
          color: #333;
          line-height: 20px;
          height: 20px;
          cursor: pointer;
          &:hover {
            background-color: #00ac8b;
            color: #fff;
          }
        }
      }
    }
  }
  .xs_form_group {
    margin-top: @xs-margin;
    margin-left: 90px;
    font-size: 12px;
    color: #333333;
  }
  .btn {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #3388ff;
    background: transparent;
  }
  .btn_special {
    width: 56px;
    height: 20px;
    line-height: 20px;
  }
  .reselect {
    margin-left: @xs-margin;
  }
  .btn_submit {
    font-size: 12px;
    color: #fff;
    background: #00ac8b;
    border-radius: 2px;
  }
  .btn_submit_special {
    margin-left: 90px;
    width: 120px;
  }
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  li {
    position: relative;
    display: inline-block;
    width: 90px;
    height: 90px;
    border-radius: 2px;
    list-style: none;
    margin-right: 20px;
    video {
      width: 90px;
      height: 90px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .cover {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 24px;
      background: rgba(0, 0, 0, 0.64);
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 24px;
      border-radius: 0 0 2px 2px;
    }
    & > .del_btn {
      position: absolute;
      z-index: 1;
      width: 20px;
      height: 20px;
      right: 2px;
      top: 2px;
      background: url(http://img.yimutian.com/crm/5d1c9ff47960423e111d01a2d8a0fcf9.png)
        no-repeat center center;
      background-size: 100%;
    }
    & > img {
      width: 90px;
      height: 90px;
      border-radius: 2px;
    }
    .play_btn {
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 30px;
    }
  }
}
.upload_area {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 90px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 2px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
}
#fileupload {
  position: absolute;
  left: 0;
  top: 0;
  width: 90px;
  height: 90px;
  opacity: 0;
  visibility: hidden;
}
.el-message-box__message video {
  width: 100%;
  max-width: 390px;
}
</style>
